import React, { Component } from "react";
import styled from "styled-components";
import DynamicHexagon from "./DynamicHexagon";

class DynamicBoard extends Component {
  constructor(props) {
    super(props);
    
	this.HexagonState = this.HexagonState.bind(this);
 }

HexagonState (hexagon) {
	this.props.HexagonState (hexagon);
}


 
  render() {
    return (
      <Container>
        <svg viewBox="0 0 1080 750">
          {[0,1,2,3,4,5,6,7,8].map(i => {
            return [0,1,2,3,4,5,6,7,8,9].map(j => {
              return (
                <>
                  <DynamicHexagon
                    number={2*i + j * 18 + 1}
                    currentColor =  {this.props.currentColor}
                    transform={"translate(" + 100 * i + "," + 60 * j + ")"}
					NumberedBoard = {this.props.NumberedBoard}
					HexagonState = {this.HexagonState} // when the Hexagon is clicked sends the Hexagon color state to the parent with a parameter of its Hexagon number
                  />
                  <DynamicHexagon 
                    number={2*i + j * 18 + 2}
                    currentColor={this.props.currentColor}
                    transform={"translate(" + (100 * i + 50) + "," + (j * 60 + 30) + ")"}
					NumberedBoard = {this.props.NumberedBoard}
					HexagonState = {this.HexagonState}
					
                  /> 
                </> 
              );
            });
          })}
        </svg>
		
		
      </Container>
    );
  }
}

export default DynamicBoard;



const Container = styled.div`
  margin-left: -1em;
`;
